<template>
    <div class="txd__fields">
        <div v-for="(field, index) in selectedTransaction.buyer_custom_fields" :key="index" class="txd__field">
            <span class="txd__label">{{ field.label }}</span>
            <span v-if="field.value !== '' && field.value !== null && field.value !== undefined" class="txd__value">{{ field.value }}</span>
            <span v-else class="txd__value txd__value--empty">—</span>
        </div>
    </div>
</template>
<script>
export default {
    props: {
        selectedTransaction: {
            type: Object,
            default: () => { },
        },
    },
}
</script>
